import {
  ApiGeneralDataResponse,
  ApiResponse,
  MoveWatchlistCardRequest,
  WatchlistData,
} from "types";
import { ApiTags } from "@shared/types";
import {
  UpdateWatchlistRequest,
  Market,
  RemoveFromWatchlistRequest,
} from "types";
import { convertToObjectsArray } from "@shared/utils/arrays";
import { sharedLib } from "@shared/services/shared.service";
import { EndpointBuilder } from "@reduxjs/toolkit/query";

export const watchlistService = sharedLib.baseApi.injectEndpoints({
  endpoints: (build: EndpointBuilder<any, any, any>) => ({
    getAllMarkets: build.query<Market[], void>({
      query: () => ({
        url: "get_all_markets/",
        method: "POST",
        body: { use_ratio: true },
      }),
      transformResponse: (
        response: ApiResponse<ApiGeneralDataResponse<any[][]>>
      ) => convertToObjectsArray(response.data.data, response.data.headers),
    }),
    getWatchlist: build.query<WatchlistData, void>({
      query: () => ({
        url: "get_watchlist/",
        method: "POST",
        body: { use_ratio: true },
      }),
      transformResponse: (
        response: ApiResponse<ApiGeneralDataResponse<any[][]>>
      ) => {
        const watchlist = convertToObjectsArray(
          response.data.data,
          response.data.headers
        );
        return {
          watchlist,
          sortedWatchlist: watchlist,
        };
      },
      keepUnusedDataFor: 0,
      providesTags: () => [{ type: ApiTags.WATCHLIST, id: "LIST" }],
    }),
    updateWatchlist: build.mutation<void, UpdateWatchlistRequest>({
      query: (args) => ({
        url: "update_watchlist/",
        method: "POST",
        body: args,
      }),
      invalidatesTags: [{ type: ApiTags.WATCHLIST, id: "LIST" }],
    }),
    removeFromWatchlist: build.mutation<void, RemoveFromWatchlistRequest>({
      query: (args) => ({
        url: "remove_from_watchlist/",
        method: "POST",
        body: args,
      }),
      invalidatesTags: [{ type: ApiTags.WATCHLIST, id: "LIST" }],
    }),
    moveWatchlistCard: build.mutation<void, MoveWatchlistCardRequest>({
      query: (args) => ({
        url: "move_watchlist_card/",
        method: "POST",
        body: args,
      }),
    }),
  }),
});
